import _ from 'lodash';
import clientsApi from '@/api/clients';

export default {
  methods: {
    /**
     * Impersonate user to client. Navigates in the current tab.
     *
     * @param {Int} clientId - Client identifier.
     */
    async impersonate(clientId) {
      const data = await clientsApi.getImpersonateUrl(clientId);
      window.location.assign(data.url);
    },

    /**
     * Impersonate user to client and go to incident view page. Navigates in the current tab.
     *
     * @param {Int} clientId - Client identifier.
     * @param {string} incidentId - Incident identifier.
     */
    async impersonateToIncident(clientId, incidentId) {
      const data = await clientsApi.getImpersonateUrl(clientId);
      window.location.assign(`${data.url}?incidentId=${incidentId}`);
    },

    /**
     * Impersonate user to client and go to a named route. Navigates in the current tab.
     *
     * @param {Int} clientId - Client identifier.
     * @param {string} route - Route name.
     * @param {Object} params - List of get params.
     */
    async impersonateToRoute(clientId, route, params = {}) {
      const data = await clientsApi.getImpersonateUrl(clientId);
      let url = `${data.url}?route=${route}`;
      _.forEach(params, (value, key) => {
        url += `&${key}=${value}`;
      });
      window.location.assign(url);
    },
  },
};
